import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import { DealGroupsRoute } from 'src/scenes/ProgrammaticDeals/components/DealGroupsRoute.tsx';
import ProgrammaticDeals from 'src/scenes/ProgrammaticDeals/index.ts';
import { dealGroupsRouterSearchParamsSchema } from 'src/scenes/ProgrammaticDeals/pages/DealGroups/schema.ts';
import { dealsRouterSearchParamsSchema } from 'src/scenes/ProgrammaticDeals/pages/Deals/schema.ts';
import { programmaticDealsRouterSearchParamsSchema } from 'src/scenes/ProgrammaticDeals/pages/Reporting/schema.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const programmaticDealsRouteObject = inferRouteObject({
  path: 'programmatic-deals',
  element: <PrivateRoute roles={Roles.PROGRAMMATIC_DEALS} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: ProgrammaticDeals.Helmet,
      children: [
        { index, element: <Navigate to='./reporting' replace /> },
        {
          path: 'reporting',
          Component: ProgrammaticDeals.Reporting,
          searchParams: programmaticDealsRouterSearchParamsSchema.parse,
        },
        {
          path: 'deals',
          Component: ProgrammaticDeals.Deals,
          searchParams: dealsRouterSearchParamsSchema.parse,
        },
        {
          path: 'deal-groups',
          element: <DealGroupsRoute />,
          searchParams: dealGroupsRouterSearchParamsSchema.parse,
          children: [
            { index, Component: ProgrammaticDeals.DealGroups },
            { path: 'create', Component: ProgrammaticDeals.DealGroupForm },
            { path: ':dealGroupId/edit', Component: ProgrammaticDeals.DealGroupForm },
            { path: ':dealGroupId/deals', Component: ProgrammaticDeals.DealGroupDeals },
          ],
        },
      ],
    },
  ],
});
